

export const GET_PRODUCTS_REDEEMABLES = 'GET_PRODUCTS_REDEEMABLES';
export const UPDATE_STOCK = 'UPDATE_STOCK';
export const CLEAN_UPDATE_STOCK = 'CLEAN_UPDATE_STOCK';